import {
  adminClient,
  organizationClient,
} from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

import { env } from "@/env/public-env";

const betterAuthBaseUrl = env.VITE_BETTER_AUTH_URL.endsWith(
  "/api/auth"
)
  ? env.VITE_BETTER_AUTH_URL
  : new URL(
      "/api/auth",
      env.VITE_BETTER_AUTH_URL
    ).toString();

export const authClient = createAuthClient({
  betterAuthBaseUrl,
  plugins: [adminClient(), organizationClient()],
});

const { signIn, signUp } = authClient;

export const { signOut } = authClient;

type AuthCallback = {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

const withAuthRedirect = <T>(
  authFn: (callbacks: AuthCallback) => Promise<T>,
  callbackURL: string
): Promise<T> => {
  return authFn({
    onSuccess: () => {
      window.location.href = callbackURL;
    },
  });
};

export const signInWithEmail = (
  email: string,
  password: string,
  callbackURL?: string
) => {
  const redirectTo = callbackURL ?? "/app/dashboard";
  return withAuthRedirect(
    (callbacks) =>
      signIn.email({ email, password }, callbacks),
    redirectTo
  );
};

export const signUpWithEmail = (
  email: string,
  password: string,
  name: string,
  callbackURL?: string
) => {
  const redirectTo = callbackURL ?? "/app/dashboard";
  return withAuthRedirect(
    (callbacks) =>
      signUp.email({ email, password, name }, callbacks),
    redirectTo
  );
};

export const signInWithGithub = (callbackURL?: string) => {
  return signIn.social({
    provider: "github",
    callbackURL: callbackURL ?? "/app/dashboard",
  });
};

export const signInWithGoogle = (callbackURL?: string) => {
  return signIn.social({
    provider: "google",
    callbackURL: callbackURL ?? "/app/dashboard",
  });
};
